import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { DashboardWidget, DashboardWidgetFC, useDashboardWidget } from '@frontend/grid-dashboard';
import { useTranslation } from '@frontend/i18n';

/**
 * @dashboard-widget
 *
 * id: new-appointment
 * title: New Appointment
 * description: Create a new appointment.
 * icon: calendar-add-small
 */
export const NewAppointmentWidget: DashboardWidgetFC = () => {
  const { t } = useTranslation('base');
  const { widgetTrackingId } = useDashboardWidget();

  return (
    <DashboardWidget.ActionButton
      trackingId={widgetTrackingId('action')}
      iconName='calendar-add'
      title={t('New Appointment')}
      onClick={() => SchedulerV3.triggerScheduleCustomEvent('schedule:new-appointment')}
    />
  );
};

NewAppointmentWidget.config = {
  size: 'tiny-slim',
  feature: 'schedule',
};
